/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Slash = ["svg", defaultAttributes, [["path", { d: "M22 2 2 22" }]]];

export { Slash as default };
//# sourceMappingURL=slash.js.map
